module.exports = __webpack_public_path__ + "img/flower-03.197873fd.png";